import { createBrowserHistory, createHashHistory  } from "history";
import { isElectron } from '../utils';

const history = isElectron() ? createHashHistory({
	basename: import.meta.env.BASE_URL
}) : createBrowserHistory({
	basename: import.meta.env.BASE_URL
});

export default history;
